const initializeSideNavAccordions = () => {
  const accordionButtons = document.querySelectorAll('.cmp-sidebar-nav__expander-button');
  accordionButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const isExpanded = button.getAttribute('aria-expanded') === 'true';
      const content = document.querySelector(`#${button.getAttribute('aria-controls')}`);

      if (isExpanded) {
        content.style.display = 'none';
        button.setAttribute('aria-expanded', 'false');
      } else {
        content.style.display = 'block';
        button.setAttribute('aria-expanded', 'true');
      }
    });
  });
};

export { initializeSideNavAccordions };
